export const environment = {
  baseUrl: 'https://api-sandbox.payee.tech/attorney',
  afterLoginPath: '/attorney',
  production: false,

  HELP_URL: 'https://help.payee.tech/hu/',
};
